import { darken } from '@mui/material';
import Chip from '@mui/material/Chip';
import React from 'react';
import { bluePlanetTheme } from 'ui/theme';
import { contrastColorRGB, convertHexToRGB, validateHexColor } from 'util/color';

interface Props {
  label: React.ReactNode;
  color?: string;
  id?: string;
  onDelete?: () => void;
  onClick?: () => void;
  outline?: boolean;
  className?: string;
}

export default function LabelChip(props: Props) {
  const validatedColor = validateHexColor(props.color || '', bluePlanetTheme.bluePlanetPalette.grey.medium);
  const hover = darken(validatedColor, 0.15);
  const color = validatedColor;
  return (
    <Chip
      onDelete={props.onDelete}
      onClick={props.onClick}
      className={props.className}
      key={props.id}
      label={props.label}
      sx={{
        color: contrastColorRGB(convertHexToRGB(validatedColor)),
        backgroundColor: color,
        border: props.outline ? `2px solid ${bluePlanetTheme.bluePlanetPalette.indigo.dark}` : 'none',

        '&:hover': {
          backgroundColor: props.onClick ? hover : color,
          cursor: props.onClick ? 'pointer' : 'inherit',
        },
      }}
    />
  );
}
